import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';

// `advancedFormat` enables the `Q` format token (e.g. "[Q]Q YYYY" -> "Q2 2026").
// `quarterOfYear` enables quarter helpers such as `startOf('quarter')`.
// Both are required by the quarterly custody date pickers.
dayjs.extend(advancedFormat);
dayjs.extend(quarterOfYear);
